<template>
  <div class="m_pagination">
    <v-row v-if="pageDatas.rowCount > 0" class="pagination box">
      <span class="my-5 page-total hidden-sm-and-down">共{{ pageDatas.rowCount }}条</span>
      <v-select v-model="pagination.limit" :items="pageSizeObjs" solo dense :menu-props="{ offsetY: true }" hide-details style="margin-top: 2px" class="small page-select ml-2 hidden-sm-and-down" @input="pageSizeChange()" />
      <span class="my-2" style="font-size: 12px">
        <v-pagination v-model="pageDatas.pageno" :total-visible="6" :length="pageDatas.pageCount" @input="pageChange()" />
      </span>
      <span class="my-5 page-total ml-4 hidden-sm-and-down">到</span>
      <v-text-field v-model="pagination.pageno" solo dense hide-details style="margin-top: 2px" class="small page-go ml-2 hidden-sm-and-down" @keyup.enter="toPage()" />
      <span class="my-5 page-total ml-2 hidden-sm-and-down">页</span>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "VtkPage",
  props: {
    pageData: {
      type: Object,
      default() {
        return {};
      },
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30],
    },
  },
  data() {
    return {
      pagination: {
        pageno: 1,
        limit: 10,
      },
      pageSizeObjs: [],
      pageDatas:this.pageData,
    };
  },
  computed: {
    paginationChange() {
      return this.pageDatas.pageno;
    },
  },
  watch: {
    paginationChange() {
      this.pagination.pageno = this.pageDatas.pageno;
    },
    pageData(newVal) {
			this.pageDatas = this.pageData;
      if (newVal.rowCount.length < 1 && newVal.rows > 0) {
        this.pageDatas.pageno = newVal.pageno - 1;
        this.pageChange();
      }
    },
  },
  mounted() {
    this.pageSizeFormat();
  },
  methods: {
    toPage() {
      const re = /^[0-9]+$/;
      if (re.test(this.pagination.pageno) && this.pagination.pageno <= this.pageDatas.pageCount) {
        this.pageDatas.pageno = parseInt(this.pagination.pageno);
        this.pageChange();
      } else {
        this.pagination.pageno = this.pageDatas.pageno;
      }
    },
    pageSizeChange() {
      this.pageDatas.pageCount = 1;
      this.pageChange();
    },
    pageSizeFormat() {
      const temp = this.pageSizes;
      temp.forEach((value) => {
        const obj = {
          text: value + "条/页",
          value: value,
        };
        this.pageSizeObjs.push(obj);
      });
      this.pagination.limit = temp[0];
    },
    pageChange() {
      const page = {
        pageno: this.pageDatas.pageno,
        limit: this.pagination.limit,
      };
      this.$emit("pageChange", page);
    },
  },
};
</script>
<style lang="scss" scoped>
.mt-1 {
  margin-top: 11px !important;
}
.my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.m_pagination {
  width: 100%;
  height: 60px;
  .box {
    position: absolute;
    bottom: 12px;
    right: 32px;
  }
}
</style>